export default __webpack_public_path__ + "static/media/search_preference.ed1d56ee.svg";